import React, { useEffect, useState, useRef } from "react";
import { HtmlDecode } from "Helpers/TextHelper";
import { useSelector, useDispatch } from "react-redux";
import { searchFieldActions } from "../../framework/redux/actions/index";
import styled from "styled-components";
import { toggleAria } from "Helpers/AriaHelper";
import { HeaderButton } from "BaseComponents/Button";
export const SearchLink = ({ text, url }) => {
	const state = useSelector(({ searchField }) => searchField);
	const dispatch = useDispatch();
	let btnRef = useRef();

	useEffect(() => {
		dispatch(searchFieldActions.set(url, text));
	}, []);

	let handleClick = (e) => {
		e.preventDefault();
		toggleAria(btnRef.current, "aria-expanded");
		dispatch(searchFieldActions.toggle(state.show));
	};

	return (
		<HeaderButton
			ref={btnRef}
			className="element-link parent-menu-link"
			onClick={(e) => handleClick(e)}
		>
			<i className="icon-search" aria-hidden="true" />
			<span>{HtmlDecode(text)}</span>
		</HeaderButton>
	);
};
